module.exports = __webpack_public_path__ + "img/accueil.4c550e73.png";